import {IconButton, ListItemIcon, ListItemText, Menu, MenuItem} from "@mui/material";
import {useState} from "react";
import {Delete, Edit, MoreVert} from "@mui/icons-material";

export default function ({quotationItem, onUpdate, onDelete, disabled = false}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);


    const handleClick = e => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleDelete = () => {
        onDelete();
        handleClose();
    }

    const handleUpdate = () => {
        onUpdate();
        handleClose();
    }

    return (
        <>
            <IconButton
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                disabled={disabled}
                data-test="quotation-item-option"
            >
                <MoreVert/>
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleUpdate} data-test="quotation-item-option-update">
                    <ListItemIcon>
                        <Edit fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Modifier</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleDelete} data-test="quotation-item-option-delete">
                    <ListItemIcon>
                        <Delete fontSize="small"/>
                    </ListItemIcon>
                    <ListItemText>Supprimer</ListItemText>
                </MenuItem>
            </Menu>
        </>
    )
}